import {mapState} from 'vuex'

export default {
  data() {
    return {
      motor_select:false,
      none_motor_select:false,
      sme_select:false,
      isShowSMEMore: false,
      class_id:[]
    }
  },
  computed: {
    classOptions(){
      let arr = this.classTypeOptions
      let data = []
      // data = index==1? arr.filter(item =>item.id>50): arr.filter(item =>item.id<50)
      data = arr.filter(item =>item.id<50)
      return data
    },
    isAllMotorSelect(){
      let arr  = this.class_id.filter(item=>[11,12,14,13,15].includes(item))||[]
      return arr.length<3&&arr.length>0
    },
    isNoneMotorSelect(){
      const data = this.noneMotorClassOptions.reduce((result, item) => {
        result.push(item.id)
        return result
      }, [])
      let none_arr = data.length
      let arr  = this.class_id.filter(item=>data.includes(item))||[]
      return arr.length<none_arr&&arr.length>0
    },
    isSMESelect(){
      const data = this.sme_class_data.reduce((result, item) => {
        result.push(item.id)
        return result
      }, [])
      let none_arr = data.length
      let arr  = this.class_id.filter(item=>data.includes(item))||[]
      return arr.length<none_arr&&arr.length>0
    },
    classTypeOptions(){
      return this.globalOptions.class_data.filter(item => item.id != 90) || []
    },
    motorClassOptions(){
      let arr = this.classTypeOptions
      let data = []
      // data = index==1? arr.filter(item =>item.id>50): arr.filter(item =>item.id<50)
      data = arr.filter(item =>[11,12,14,13,15].includes(item.id))
      return data
    },
    noneMotorClassOptions(){
      let arr = this.classTypeOptions
      let data = []
      data = arr.filter(item =>item.id<50&&![11,12,14,13,15].includes(item.id))
      return data
    },
    all_class_data(){
      return [...this.classOptions,...this.sme_class_data]
    },
    sme_class_data(){
      let {sme_class_data} = this.globalOptions||{}
      return sme_class_data||[]
    },
  },
  mounted(){

  },
  watch:{
  },
  methods: {
    handleSelectQuote(){
      if(this.motor_select){
        this.class_id = [...this.class_id,11,12,14,13,15]
      }else {
        this.class_id  = this.class_id.filter(item=>![11,12,14,13,15].includes(item))
      }
      this.filterData(this.is_ticket?this.type:'')
    },
    handleSelectNoneQuote(){
      const data = this.noneMotorClassOptions.reduce((result, item) => {
        result.push(item.id)
        return result
      }, [])
      if(this.none_motor_select){
        this.class_id = [...this.class_id,...data]
      }else {
        this.class_id  = this.class_id.filter(item=>!data.includes(item))
      }
      this.filterData(this.is_ticket?this.type:'')
    },
    handleSelectSMEQuote(){
      const data = this.sme_class_data.reduce((result, item) => {
        result.push(item.id)
        return result
      }, [])
      if(this.sme_select){
        this.class_id = [...this.class_id,...data]
      }else {
        this.class_id  = this.class_id.filter(item=>!data.includes(item))
      }
      this.filterData(this.is_ticket?this.type:'')
    },
  }
}
